var map = {
	"./argentina-logo-icon.png": "a3f3",
	"./australia-logo-icon.png": "9b99",
	"./benetton-rugby-logo-icon.png": "b9bc",
	"./blue-bulls-logo-icon.png": "b1c5",
	"./bulls-logo-icon.png": "9847",
	"./cardiff-rugby-logo-icon.png": "873f",
	"./chile-logo-icon.png": "1574",
	"./connacht-rugby-logo-icon.png": "1c8e",
	"./dragons-rfc-logo-icon.png": "995b",
	"./edinburgh-rugby-logo-icon.png": "cf8e",
	"./england-logo-icon.png": "a202",
	"./figi-logo-icon.png": "495f",
	"./fiji-logo-icon.png": "2341",
	"./france-logo-icon.png": "f337",
	"./free-state-cheetahs-logo-icon.png": "1e85",
	"./georgia-logo-icon.png": "5bd7",
	"./glasgow-warriors-logo-icon.png": "d21e",
	"./griffons-logo-icon.png": "7870",
	"./griquas-logo-icon.png": "3e91",
	"./ireland-logo-icon.png": "faa2",
	"./italy-logo-icon.png": "54e3",
	"./japan-logo-icon.png": "6ab2",
	"./leinster-rugby-logo-icon.png": "9289",
	"./lions-logo-icon.png": "8635",
	"./munster-rugby-logo-icon.png": "c62a",
	"./namibia-logo-icon.png": "c691",
	"./new-zealand-logo-icon.png": "c087",
	"./new-zealend-logo-icon.png": "ed3b",
	"./ospreys-logo-icon.png": "6612",
	"./portugal-logo-icon.png": "7bd5",
	"./pumas-logo-icon.png": "ca73",
	"./romania-logo-icon.png": "efb4",
	"./samoa-logo-icon.png": "4fd4",
	"./scarlets-logo-icon.png": "3078",
	"./scotland-logo-icon.png": "5fb7",
	"./sharks-logo-icon.png": "b21a",
	"./sharks-xv-logo-icon.png": "52de",
	"./sigma-lions-logo-icon.png": "1421",
	"./south-africa-logo-icon.png": "def4",
	"./stormers-logo-icon.png": "29da",
	"./tonga-logo-icon.png": "80e3",
	"./ulster-rugby-logo-icon.png": "7606",
	"./uruguay-logo-icon.png": "b343",
	"./wales-logo-icon.png": "23ef",
	"./western-province-logo-icon.png": "a5c3",
	"./zebre-parma-logo-icon.png": "5683"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0a2";